import { Breakpoint } from 'antd';

export const getCanvasDimensions = (
	MAX_WIDTH: number,
	SIDE_PADDING: number,
	screens: Partial<Record<Breakpoint, boolean>>
) => {
	const deviceWidth = window.innerWidth;
	const maxPossibleWidth = Math.min(MAX_WIDTH, deviceWidth);
	const canvasWidth = (screens.xs ? deviceWidth : maxPossibleWidth) - SIDE_PADDING;

	const canvasHeight = Math.floor(canvasWidth / 4); // Computing height based on width to keep aspect ratio 1:4

	return { canvasWidth, canvasHeight };
};
